const initialState = {};

const Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SAVE_BoardColumns":
      return { ...state, Columns: payload };
    case "CLEAR":
      return initialState;
    default:
      return state;
  }
};

export default Reducer;
